import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FaBars, FaChair, FaSignOutAlt, FaExpand, FaCompress, FaUsers } from 'react-icons/fa';
import { IoRestaurant } from 'react-icons/io5';
import { MdEmail } from 'react-icons/md';
import './MobileNavBar.css';

const MobileNavBar = () => {
  const { user, signOut } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement) {
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      }
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      }
      setIsFullscreen(false);
    }
  };

  const screens = [
    { id: 'floor-plan', name: 'Резервации', icon: <FaChair />, path: '/floor-plan' },
    { id: 'customers', name: 'Гости', icon: <FaUsers />, path: '/customers' },
    { id: 'edit', name: 'Локал', icon: <IoRestaurant />, path: '/edit' },
    { id: 'mail', name: 'Мејлови', icon: <MdEmail />, path: '/email' },
  ];

  const logoSrc = 'https://qglldlnkkypojvppmqzs.supabase.co/storage/v1/object/public/restoranisliki//logonotext.png';

  return (
    <>
      <div className="mobile-nav-bar">
        <img
          className="mobile-nav-logo"
          src={logoSrc}
          alt="Restaurant Logo"
        />
        <button
          className="hamburger-button"
          onClick={toggleMenu}
          aria-label="Toggle Menu"
        >
          <FaBars />
        </button>
      </div>
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <div className="mobile-nav-tabs">
            {screens.map(screen => (
              <NavLink
                key={screen.id}
                to={screen.path}
                className={({ isActive }) => `mobile-nav-tab ${isActive ? 'active' : ''}`}
                aria-label={screen.name}
                onClick={toggleMenu}
              >
                <span className="mobile-nav-icon">{screen.icon}</span>
                <span className="mobile-nav-text">{screen.name}</span>
              </NavLink>
            ))}
          </div>
          {user && (
            <div className="mobile-nav-footer">
              <button
                onClick={toggleFullscreen}
                className="mobile-fullscreen-button"
                aria-label={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
              >
                <span className="mobile-nav-icon">{isFullscreen ? <FaCompress /> : <FaExpand />}</span>
                <span className="mobile-nav-text">{isFullscreen ? 'Излези од цел екран' : 'Цел екран'}</span>
              </button>
              <button
                onClick={() => {
                  signOut();
                  toggleMenu();
                }}
                className="mobile-sign-out-button"
                aria-label="Sign Out"
              >
                <span className="mobile-nav-icon"><FaSignOutAlt /></span>
                <span className="mobile-nav-text">Одјави се</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MobileNavBar;